import {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useMemo,
  useState
} from "react";
import { InterviewService } from "../../../../services/InterviewService";
import { ReactDropdownTreeSelectMemoized } from "../../../dropdownTree.container";

const Mobility = forwardRef(({ searchObject, setSearchObject, t }, ref) => {
  const [mobilities, setMobilities] = useState([]);
  const [mobilityData, setmobilityData] = useState([]);

  useEffect(() => {
    InterviewService.getAllMobilityInterview().then((data) => {
      setmobilityData([...data]);
      if (searchObject.mobility)
        for (let selected of searchObject.mobility) {
          setSelected(selected, data);
        }
      setMobilities(data);
    });
  }, []);
  //is usedOutside Component
  useImperativeHandle(ref, () => ({
    reset() {
      clearSelected(mobilityData);
    }
  }));

  function setSelected(selected, mobilitiesData) {
    for (let mobility of mobilitiesData) {
      if (mobility.children.length > 0) {
        // recursive
        setSelected(selected, mobility.children);
      }
      if (mobility.value === selected) mobility.checked = true;
    }
  }

  function clearSelected(mobilitiesData) {
    for (let mobility of mobilitiesData) {
      if (mobility.children.length > 0) {
        // recursive
        clearSelected(mobility.children);
      }
      mobility.checked = false;
    }
  }

  const onChangeForIntegers = useMemo(
    () => (_, selectedValues) => {
      let values = [...selectedValues].map((x) => x.value);
      let _searchObject = { ...searchObject };
      _searchObject.mobility = values;
      setSearchObject(_searchObject);
      if (_searchObject.mobility) {
        clearSelected(mobilities);
        for (let selected of _searchObject.mobility) {
          setSelected(selected, mobilities);
        }
      }
    },
    [setSearchObject, searchObject, mobilities]
  );

  return (
    <div>
      <legend className="fontsize-legend">{t("Mobility")}</legend>
      <ReactDropdownTreeSelectMemoized
        data={mobilities}
        onChange={onChangeForIntegers}
        className="fontsize-legend"
      />
    </div>
  );
});
export default Mobility;
